import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import {
  metricTitleMap,
  pcConsoleGameMetric,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/baseConfig';
import { getMobileDetailDownloadTitle } from '@intelligence/components/DownloadCommon/DownloadPage/common/baseSetting';
import {
  pipe,
  getRegionMarket,
} from '@intelligence/components/DownloadCommon/DownloadPage/utils';
import {
  setGameTitle,
  setItem,
  setMetricTitle,
  setPercentForPCConsole,
  setTitleByCompanyShow,
  setTitleByDateMethod,
  setTitleByGenreShow,
  setTitleByPlatform,
  setTitleByRegionMethod,
  setTitleByReleaseDateShow,
  setTitleBySteamIdShow,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/titleSettingAtom';
import {
  getFileFormatByKey,
  getPlatformByKey,
  getRegionValueByKey,
  setMetricsByList,
  setTimingByDateMethod,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/summarySettingAtom';
import { isArray, merge, union } from 'lodash-es';
import { getPlatformCacaderValues } from '@intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { getOrderedMetricEntriesFromParams } from '@intelligence/components/DownloadCommon/DownloadPage/utils/reorderCombineDetailDownloadMetrics';
const newMetricMap = {
  ...metricTitleMap,
  ...pcConsoleGameMetric,
};
const merges = (data, t) => {
  const first = Object.keys(t);
  first.forEach((item) => {
    if(isArray(data[item])) {
      data[item] = union(data[item], t[item]);
    } else {
      data[item] = merges(data[item], t[item]);
    }
  });
  return data;
};
const sourceDownloadSegment: Record<string, string[]> = {
  mscience: [
    'All',
    'Full Game',
    'DLC: All Other',
    'DLC: Expansion',
    'DLC: Season Pass',
    'DLC: Battle Pass',
    'MTX',
    'Subscription',
  ],
  gsd: ['All', 'Full Game', 'Game', 'Add-On', 'In-Game Currency'],
  vginsights: ['All'],
  newzoo: ['All'],
  newzoo_weight: ['All'],
  npd: ['All'],
};
const mergeData = function (params: Record<string, any> = {}) {
  const result: { Metric: string; Segment?: string; Source: string }[] = [];

  let segments = sourceDownloadSegment;
  // 如果是新segment且包含metric_condition字段，则做过滤
  if (params?.metric_condition) {
    const newMetricCondition = params.metric_condition || {};
    const newMetricObj: any = { ...newMetricCondition };
    Object.entries(newMetricObj)?.forEach(([key, value]) => {
      newMetricObj[key] = value?.segments || [];
    });
    segments = {
      ...segments,
      ...newMetricObj,
    };
  }
  if (params?.segment_method !== 'aggregated') {
    segments = params?.segmentsByDownload;
  }
  const orderedMetricEntries = getOrderedMetricEntriesFromParams(params);

  orderedMetricEntries.forEach(({ dataSource: key, metric }) => {
    const currentSegments = segments[key] || [];

    if (params.segment_method === 'aggregated') {
      result.push({ Metric: metric, Source: '' });
    } else if (currentSegments?.length) {
      currentSegments.forEach((segment: any) => {
        result.push({ Metric: metric, Segment: segment, Source: '' });
      });
    } else {
      result.push({ Metric: metric, Segment: '', Source: '' });
    }
  });

  return result;
};
const getSheetNames = (params: Record<string, any> = {}) => {
  const metricList = mergeData(params);
  const pipeFront = pipe(
    setGameTitle,
    setTitleByDateMethod(params.downlaod_date_method),
    setTitleByCompanyShow(params.company_show),
    setTitleByGenreShow(params.genre_show),
    setTitleByReleaseDateShow(params.release_date_show),
    setTitleBySteamIdShow(params.steam_id_show),
    setTitleByRegionMethod(params.region_method),
    setTitleByPlatform(params.device_method),
  );
  const pipeInLoop = pipe(
    setItem,
    setMetricTitle(newMetricMap, params.date_type, 'isObject'),
    setPercentForPCConsole(params.ratio_show),
  );

  const excelTitleList = getMobileDetailDownloadTitle(
    pipeFront,
    metricList,
    pipeInLoop,
  );
  const sheetNames =
    params?.date_method !== 'aggregated' ? 'Stats-Monthly' : 'Stats';
  return {
    sheetName: [sheetNames],
    [sheetNames]: excelTitleList,
  };
};

// 外部传入数据，转为下载接口所需要参数
const getDownloadApiParams = (params: any) => {
  const {
    region_method,
    device_method,
    device,
    downlaod_date_method,
    segment_method,
    segment,
    date_type,
    entity_type,
    metric_condition = {},
    source_metrics,
    start_date,
    end_date,
    unified_ids,
  } = params;

  return {
    ids: unified_ids ? unified_ids : [],
    entity_type,
    markets:
      region_method === 'aggregated'
        ? params?.regions
        : getRegionMarket(params),
    granularity: date_type,
    start_date,
    end_date,
    platforms: device,
    source_metrics,
    segments: segment ? [segment] : ['All'],
    start_release_time: 0,
    end_release_time: 0,
    b_group_by_market: region_method === 'market',
    b_group_by_region: region_method === 'region',
    b_group_by_date: downlaod_date_method !== 'aggregated',
    b_group_by_segment: segment_method !== 'aggregated',
    b_group_by_platform: device_method === 'separate',
    b_group_by_device: device_method === 'device',
    b_growth_ratio: params.ratio_show === 1 || params.ratio_show === '1',
    b_download: true,
    company_show: params?.company_show === 1 || params?.company_show === '1',
    genre_show: params?.genre_show === 1 || params?.genre_show === '1',
    steam_id_show: params?.steam_id_show === 1 || params?.steam_id_show === '1',
    release_date_show:
      params?.release_date_show === 1 || params?.release_date_show === '1',
    metric_condition:
      segment_method !== 'aggregated'
        ? merges(
            metric_condition,
            getPlatformCacaderValues(params?.segmentsByDownload || {}),
          )
        : metric_condition,
    adjust_metric: params?.adjust_metric ?? true,
  };
};

const getSummarySheet = (params: Record<string, any>) => {
  const list: any[] = [];
  const { region_method, file_format, source_metrics } = params || {};
  const setSummarySheet = pipe(
    getPlatformByKey(params),
    setTimingByDateMethod(params),
    setMetricsByList(source_metrics, newMetricMap),
    getRegionValueByKey(region_method),
    getFileFormatByKey(file_format),
  );
  setSummarySheet(list);
  return list;
};
const granularityObject: Record<string, string> = {
  daily: 'D',
  weekly: 'W',
  monthly: 'M',
};
const getFileName = (params: any) => {
  const {
    start_release_time,
    start_date,
    end_release_time,
    end_date,
    granularity,
    new_style_donwload_file_name,
  } = params;
  const gItem = granularityObject[granularity];
  if (start_date && end_date) {
    return `${new_style_donwload_file_name}_${start_date}_${end_date}`;
  }
  if (start_release_time && end_release_time) {
    return `${new_style_donwload_file_name}_Release_${gItem}${start_release_time}_${gItem}${end_release_time}`;
  }
  return `${new_style_donwload_file_name}`;
};
export default (params: Record<string, any>) => {
  params = JSON.parse(JSON.stringify(params));
  return {
    ...commonSetting,
    isUsingNewMethod: false,
    $$fileName: getFileName(params),
    downloadFetchApi: '/api/v1/intelligence_pc/compare/pcConsoleMetricData',
    dataKey: undefined,
    summarySheet: getSummarySheet(params),
    regionOptions: params?.regionOptions,
    byDate: params?.downlaod_date_method !== 'aggregated',
    granularity: granularityObject[params?.granularity],
    isRelease: !!(params?.end_release_time && params?.start_release_time),
    downloadApiParams: getDownloadApiParams(params),
    fetchOnlyOnce: true,
    downloadMode: 'commonConf',
    downloadConfigKey: 'pc_console_kpi_trends',
    ...getSheetNames(params),
  };
};
